<ng-container [formGroup]="newEditForm">
    <td class="long" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="marcas" [selectedItem]="newEditForm.get('marca')" [disabled]="disabledMarca" [placeHolder]="false">
        </app-filterable-list>
    </td>
    <td class="long" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="allGrupoEtiquetasCaja" [selectedItem]="newEditForm.get('grupoEtiquetasCaja')" [disabled]="disabledCaja" [placeHolder]="false">
        </app-filterable-list>
    </td>
    <td class="long" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="allGrupoEtiquetasPallet" [selectedItem]="newEditForm.get('grupoEtiquetasPallet')" [disabled]="disabledPallet" [placeHolder]="false">
        </app-filterable-list>
    </td>
    <td class="long" [ngClass]="{'show-error': showError}">
        <input type="checkbox" id="{{'destino' + randomId}}" formControlName="destinoRequerido">
        <label for="{{'destino' + randomId}}"></label>
    </td>
    <td class="multi-actions">
        <ng-container *ngIf="editable">
            <i class="far fa-save"title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="fas fa-pencil-alt"title="{{'titles.editar' | translate}}" (click)="edit(marcaPaisDenominacion)"></i>
            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" [ngClass]="{'disabled': marcaPaisDenominacion && marcaPaisDenominacion.registroEnUso}" app-click-stop-propagation (click)="askDelete(marcaPaisDenominacion)"></i>
        </ng-container>
    </td>
    <app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
</ng-container>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
